import React from "react";

class LoginFooter extends React.Component {
    render() {
        const currentYear = new Date().getFullYear();
        return (
            <footer
                style={{
                    position: "fixed",   // stick to bottom
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    lineHeight: "3vh",
                    backgroundColor: "#f0f0f0",
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#6c757d ",
                    padding: "5px",
                    paddingLeft: "85px",
                    textAlign: "left",
                    borderTop: "1px solid #ddd",
                    zIndex: 1000,
                    unicodeBidi: "isolate",
                }}
            >
                © {currentYear} - Exdion iStudio -{" "}
                <a style={{ color: "#0366d6" }} 
                    href="/PrivacyPolicy.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy
                </a>
            </footer>
        );
    }
}

export default LoginFooter;
